import { type SetFightsProps, type Fight } from 'src/types'

const setFights = (dispatch: (arg0: SetFightsProps) => void, fights: Record<string, Fight>) => {
  dispatch({
    type: 'SET_FIGHTS',
    fights
  })
}

export {
  setFights
}
